<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { FLOW_TRIGGER_EVENTS } from '../../constants';

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  inboxes: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['update']);

const { t } = useI18n();

const data = computed(() => props.data);

const onEventChange = event => {
  emit('update', { event_name: event.target.value });
};

const onInboxChange = event => {
  const value = event.target.value;
  if (value === '') {
    emit('update', { inbox_id: null, inbox_name: null });
  } else {
    const inbox = props.inboxes.find(i => i.id === parseInt(value, 10));
    emit('update', {
      inbox_id: parseInt(value, 10),
      inbox_name: inbox?.name || null,
    });
  }
};
</script>

<template>
  <div class="flex flex-col gap-3">
    <div class="flex flex-col gap-1.5">
      <label class="text-[11px] font-medium text-n-slate-11">
        {{ t('FLOW_BUILDER.NODE_EDITOR.TRIGGER.EVENT') }}
      </label>
      <select
        :value="data.event_name"
        class="w-full px-3 py-2 text-sm border border-n-weak dark:border-n-strong rounded-lg bg-transparent text-n-slate-12 outline-none focus:border-n-blue-5"
        @change="onEventChange"
      >
        <option
          v-for="event in FLOW_TRIGGER_EVENTS"
          :key="event"
          :value="event"
        >
          {{
            t(`FLOW_BUILDER.NODE_EDITOR.TRIGGER.EVENTS.${event.toUpperCase()}`)
          }}
        </option>
      </select>
    </div>
    <div
      class="flex flex-col gap-1.5 pt-2 border-t border-n-slate-2 dark:border-n-slate-3"
    >
      <label class="text-[11px] font-medium text-n-slate-11">
        {{ t('FLOW_BUILDER.NODE_EDITOR.TRIGGER.INBOX') }}
      </label>
      <select
        :value="data.inbox_id || ''"
        class="w-full px-3 py-2 text-sm border border-n-weak dark:border-n-strong rounded-lg bg-transparent text-n-slate-12 outline-none focus:border-n-blue-5"
        @change="onInboxChange"
      >
        <option value="">
          {{ t('FLOW_BUILDER.NODE_EDITOR.TRIGGER.ALL_INBOXES') }}
        </option>
        <option v-for="inbox in inboxes" :key="inbox.id" :value="inbox.id">
          {{ inbox.name }}
        </option>
      </select>
    </div>
  </div>
</template>
